import styled from 'styled-components';

/**
 * Styled container for the multi-select checkbox dropdown component
 * Includes styles for dropdown control, menu, options, search, and scrollbar
 */
const SOSMultiSelectDropDownContainer = styled.div`
  position: relative;
  width: 100%;
  font-size: 0.875rem;

  /* Main dropdown control button */
  .dropdown-control {
    min-height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 4px 11px;
    cursor: pointer;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: #6846d1;
    }

    &.open {
      border-color: #6846d1;
      box-shadow: 0 0 0 2px rgba(104, 70, 209, 0.1);
    }
  }

  /* Selected items display area */
  .dropdown-title {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #1f2937;
    font-weight: 500;
  }

  .placeholder {
    color: #9ca3af;
    font-weight: 400;
  }

  /* Dropdown arrow icon */
  .dropdown-arrow {
    margin-left: 8px;
    color: #6846d1;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }

  /* Dropdown menu container */
  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid rgba(104, 70, 209, 0.15);
    border-radius: 6px;
    margin-top: 4px;
    box-shadow: 0 4px 12px rgba(104, 70, 209, 0.12);
    z-index: 1000;
    max-height: 280px;
    display: flex;
    flex-direction: column;
  }

  /* Sticky header containing search and select all */
  .dropdown-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
    border-radius: 6px 6px 0 0;
  }

  /* Search input container */
  .search-container {
    position: relative;
    border-bottom: 1px solid rgba(104, 70, 209, 0.1);
  }

  .search-input {
    width: 100%;
    padding: 8px 30px 8px 12px;
    border: none;
    font-size: 0.875rem;
    outline: none;
    transition: background 0.3s ease;

    &:focus {
      background: #faf9fe;
    }
  }

  /* Clear search button */
  .search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #9ca3af;
    font-size: 0.875rem;
    padding: 4px;
    display: flex;
    align-items: center;
    transition: color 0.2s ease;

    &:hover {
      color: #6846d1;
    }
  }

  /* Select all option styling */
  .select-all-option {
    padding: 8px 12px;
    border-bottom: 1px solid rgba(104, 70, 209, 0.1);
    background: linear-gradient(to right, #faf9fe, #ffffff);
    transition: background 0.2s ease;

    &:hover {
      background: linear-gradient(to right, #f3f0ff, #faf9fe);
    }
  }

  /* Scrollable options container */
  .options-container {
    overflow-y: auto;
    flex: 1;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f3f4f6;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to bottom, #6846d1, #8b5cf6);
      border-radius: 4px;

      &:hover {
        background: linear-gradient(to bottom, #5a3bb8, #7c4ddb);
      }
    }
  }

  /* Individual option styling */
  .option {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #faf9fe;
    }

    input[type='checkbox'] {
      margin-right: 10px;
      cursor: pointer;
      accent-color: #6846d1;
      flex-shrink: 0;
      width: 16px;
      height: 16px;

      &:checked {
        background: #6846d1;
      }
    }

    label {
      cursor: pointer;
      user-select: none;
      flex: 1;
      line-height: 1.5;
      overflow-wrap: break-word;
      color: #374151;
    }
  }

  /* No options found message */
  .no-options {
    padding: 16px;
    text-align: center;
    color: #9ca3af;
    font-size: 0.875rem;
  }

  /* Sticky footer with Apply / Clear All action buttons */
  .dropdown-footer {
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 12px;
    background: white;
    border-top: 1px solid rgba(104, 70, 209, 0.12);
    border-radius: 0 0 6px 6px;
  }
`;

export default SOSMultiSelectDropDownContainer;
